import objectPath from "object-path";
import React, { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { QuickUserToggler } from "../extras/QuiclUserToggler";
import ActivityLogDrawer from "./ActivityLogDrawer";

export function Topbar() {
  const uiService = useHtmlClassService();
  const { user } = useSelector((state) => state.auth);
  const role = user.data.roles[0].name;

  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
    };
  }, [uiService]);

  return (
    <div className="topbar">
      {layoutProps.viewQuickPanelDisplay && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-panel-tooltip">Activity Log</Tooltip>}
        >
          <div
            className="topbar-item"
            data-toggle="tooltip"
            title="Activity Log"
            data-placement="right"
          >
            {role == "owner" ?? <ActivityLogDrawer />}
          </div>
        </OverlayTrigger>
      )}
      {layoutProps.viewUserDisplay && <QuickUserToggler />}
    </div>
  );
}
